import { LoadPanel, Popup } from "devextreme-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { CreateEditApp } from "../../../Components/CreateEditApp";
import { ProductList } from "./ProductList";
import { Pagination } from "./Pagination";
import { AppListFunction } from "./AppListFunction";
import { setViewData } from "../../../Reducer/DashboardReducer";
import { useDispatch } from "react-redux";

const CreateAppPopup = ({ setcraeteAppShow, craeteAppShow, GetProduct }) => {
  return (
    <>
      <Popup
        visible={craeteAppShow}
        onHiding={() => {
          setcraeteAppShow(false);
        }}
        showTitle={false}
        width={455}
        height={619}
        showCloseButton={true}
        hideOnOutsideClick={true}
      >
        <CreateEditApp
          craeteAppShow={craeteAppShow}
          setcraeteAppShow={setcraeteAppShow}
          type={0}
          GetProduct={GetProduct}
        />
      </Popup>
    </>
  );
};

export const AppList = () => {
  const [dataDisplay, setdataDisplay] = useState([]);
  const [dataDisplayCount, setdataDisplayCount] = useState(0);
  const dispatch = useDispatch();
  const clas = new AppListFunction();
  const [pagecount, setpagecount] = useState(1);
  const [page_limit, setpage_limit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [craeteAppShow, setcraeteAppShow] = useState(false);
  const [search, setsearch] = useState(undefined);
  const [firtst, setfirtst] = useState(0);
  const [last, setlast] = useState(page_limit);

  useEffect(() => {
    dispatch(setViewData({}));
  }, [dispatch]);

  const GetProduct = () => {
    clas.GetProduct(
      setLoading,
      setdataDisplay,
      setdataDisplayCount,
      search,
      pagecount,
      page_limit
    );
  };

  const clasRef = useRef(clas);

  const fetchProducts = useCallback(() => {
    clasRef.current.GetProduct(
      setLoading,
      setdataDisplay,
      setdataDisplayCount,
      search,
      pagecount,
      page_limit
    );
  }, [pagecount, page_limit, search]);

  useEffect(() => {
    const pattern = /[^ ]/;
    fetchProducts();
    if (pattern.test(search) || search.length === 0) {
      if (search !== undefined) {
        const timeoutId = setTimeout(() => {
          fetchProducts();
          setpagecount(1);
          setfirtst(0);
          setlast(page_limit);
        }, 900);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [pagecount, fetchProducts, page_limit, search]);

  return (
    <>
      <CreateAppPopup
        setcraeteAppShow={setcraeteAppShow}
        craeteAppShow={craeteAppShow}
        GetProduct={GetProduct}
      />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <div className="dashboard__body">
        <div className="dashboard__header">
          <h1 className="title title--h1">All Apps</h1>
          <button
            onClick={() => {
              setcraeteAppShow(true);
            }}
            className="btn btn--primary"
            data-toggle="modal"
            data-target="#CreateAppModal"
          >
            Create App
            <svg
              className="icon"
              width={11}
              height={11}
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16748 1.13403V9.62565"
                stroke="white"
                strokeWidth="1.69832"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M0.922363 5.37988H9.41398"
                stroke="white"
                strokeWidth="1.69832"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="filter">
          <div className="filter__item form">
            <input
              className="form-control form__input--search"
              style={{ height: "44px" }}
              type="text"
              placeholder="Search for Applications"
              onChange={(e) => {
                setsearch(e.target.value);
              }}
            />
          </div>
        </div>

        <>
          <div
            style={{ padding: "0px", marginTop: "15px" }}
            className="whiteBox whiteBox--space"
          >
            <div>
              <ul className="responsive-table">
                <li
                  style={{
                    borderBottom: "1px solid rgb(192 184 184 / 34%)",
                    borderRadius: "0px",
                    padding: "6px 0px 6px 0px",
                  }}
                  className="table-header"
                >
                  <div style={{ textAlign: "center" }} className="col heading">
                    App Logo
                  </div>
                  <div style={{ textAlign: "center" }} className="col heading">
                    App Name
                  </div>
                  <div style={{ textAlign: "center" }} className="col heading">
                    Client Id
                  </div>
                  <div style={{ textAlign: "center" }} className="col heading">
                    Creation Date
                  </div>
                  <div className="col heading" style={{ textAlign: "center" }}>
                    Action
                  </div>
                </li>
                {dataDisplay?.length ? (
                  <div
                    style={{
                      height: "calc(100vh - 295px)",
                      overflow: "auto",
                    }}
                  >
                    {dataDisplay?.map((val, index) => {
                      return (

                        <ProductList Data={val} key={index} />

                      );
                    })}
                  </div>
                ) : (
                  !dataDisplay?.length && (
                    <div
                      style={{
                        height: "calc(100vh - 309px)",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <p>No Data Found.</p>
                    </div>
                  )
                )}
              </ul>
            </div>
            <Pagination
              setpagecount={setpagecount}
              pagecount={pagecount}
              dataDisplayCount={dataDisplayCount}
              page_limit={page_limit}
              setlast={setlast}
              last={last}
              setfirtst={setfirtst}
              firtst={firtst}
              setpage_limit={setpage_limit}
            />
          </div>
        </>
      </div>
    </>
  );
};
